import styled from 'styled-components';

export const HeaderWrap = styled.div`
    width:100%;
    display:flex;
    background:#fff url(../assets/hdrBg.jpg) no-repeat center;
    background-size:1440px;
    margin:0 auto;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.16);
  }
`;
